import { User } from "../models/User";
import { load } from "./basic-loader";

export async function doLogin(email:string, password:string){
    return await load("api/v1/get-token", {}, {email, password}) as User
}

export async function validateToken(token:string){
    return await load("api/v1/validate-token", {}, {token}) as User
}